/**
 * DiCon Incident Service API
 * API used by DiCon, LiOn and Buefo.
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: dienstleistung@netze-bw.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IncidentLightingPointRelation1 } from './incidentLightingPointRelation1';
import { NetArea } from './netArea';


export interface ControlCabinetLocationDataV2 { 
    customerScope?: string;
    longitude?: number;
    latitude?: number;
    featureId?: string;
    zipCode?: string;
    city?: string;
    district?: string;
    street?: string;
    houseNumber?: string;
    netArea?: NetArea;
    lastCompletedDate?: string;
    incident?: IncidentLightingPointRelation1;
    number?: string;
}
export namespace ControlCabinetLocationDataV2 {
}


